import { Method } from '@ori-events/add-to-basket';
export const Name = 'loyalty-dialog-result';
export const LoyaltyDialogResultEvent = Name;
export let LoyaltyDialogResults = /*#__PURE__*/function (LoyaltyDialogResults) {
  LoyaltyDialogResults["CLOSE"] = "CLOSE";
  return LoyaltyDialogResults;
}({});
export { Method };
export let Results = function (Results) {
  Results["CLOSE"] = "CLOSE";
  Results[Results["BUY_FOR_MONEY"] = Method.BUY_FOR_MONEY] = "BUY_FOR_MONEY";
  Results[Results["BUY_FOR_POINTS"] = Method.BUY_FOR_POINTS] = "BUY_FOR_POINTS";
  return Results;
}({});
export const isLoyaltyBuyForMoneyResult = result => result === Method.BUY_FOR_MONEY;
export const isLoyaltyBuyForPointsResult = result => result === Method.BUY_FOR_POINTS;
export const isLoyaltyCloseResult = result => result === LoyaltyDialogResults.CLOSE;
//# sourceMappingURL=index.js.map